import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { VSpace, McInputNew, McTextAreaNew } from "../../../../../components";
import { RomEllerUtstyrEnum } from "../../../../../mc-shared/gkReportConstants";
import { IGKRapport } from "../../../../../mc-shared/reportSchemas/gkReportSchema";
import { Paper, Stack, Title } from "@mantine/core";
const GKgenerellInfo: React.FC<{
  data: IGKRapport;
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
}> = ({ data, onUpdateEditData }) => {
  return (
    <div>
      {data != null && (
        <>
          <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
            <Stack gap="xs">
              <Title order={4} fw={400}>GK-Rapport</Title>
              <Title order={4} fw={400}>Generell info:</Title>
              <div className="d-flex justify-content-between">
                <div style={{ width: "40%" }}>
                  <McInputNew
                    label="Oppdrag:"
                    value={data.generellInfo?.oppdragsnavn}
                    onChange={(e) => onUpdateEditData("generellInfo.oppdragsnavn", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Emne:"
                    value={data.generellInfo?.emne}
                    onChange={(e) => onUpdateEditData("generellInfo.emne", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Oppdragsgiver:"
                    value={data.generellInfo?.oppdragsgiver}
                    onChange={(e) => onUpdateEditData("generellInfo.oppdragsgiver", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Kontaktperson:"
                    value={data.generellInfo?.kontaktperson}
                    onChange={(e) => onUpdateEditData("generellInfo.kontaktperson", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Kopi:"
                    value={data.generellInfo?.kopi}
                    onChange={(e) => onUpdateEditData("generellInfo.kopi", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Etasje:"
                    value={data.generellInfo?.etasje}
                    onChange={(e) => onUpdateEditData("generellInfo.etasje", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Rom Nr.:"
                    value={data.generellInfo?.romNr}
                    onChange={(e) => onUpdateEditData("generellInfo.romNr", e.target.value)}
                  />
                  {data.testInnstillinger.valgtRomEllerUtstyr === RomEllerUtstyrEnum.UTSTYR && (
                    <>
                      <VSpace />
                      <McInputNew
                        label="Utstyr:"
                        value={data.generellInfo?.utstyr}
                        onChange={(e) => onUpdateEditData("generellInfo.utstyr", e.target.value)}
                      />
                    </>
                  )}
                </div>
                <div style={{ width: "40%" }}>
                  <McInputNew
                    label="Dokumentkode:"
                    value={data.generellInfo?.dokumentkode}
                    onChange={(e) => onUpdateEditData("generellInfo.dokumentkode", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Tilgjengelighet:"
                    value={data.generellInfo?.tilgjengelighet}
                    onChange={(e) => onUpdateEditData("generellInfo.tilgjengelighet", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Oppdragsleder:"
                    value={data.generellInfo?.oppdragsleder}
                    onChange={(e) => onUpdateEditData("generellInfo.oppdragsleder", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Utarbeidet av:"
                    value={data.generellInfo?.utarbeidetAv}
                    onChange={(e) => onUpdateEditData("generellInfo.utarbeidetAv", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Ansvarlig enhet:"
                    value={data.generellInfo?.ansvarligEnhet}
                    onChange={(e) => onUpdateEditData("generellInfo.ansvarligEnhet", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Sted:"
                    value={data.generellInfo?.sted}
                    onChange={(e) => onUpdateEditData("generellInfo.sted", e.target.value)}
                  />
                  <VSpace />
                  <McInputNew
                    label="Dato:"
                    value={data.generellInfo?.dato}
                    onChange={(e) => onUpdateEditData("generellInfo.dato", e.target.value)}
                    type="date"
                  />
                  {data.testInnstillinger.valgtRomEllerUtstyr === RomEllerUtstyrEnum.UTSTYR && (
                    <>
                      <VSpace />
                      <McInputNew
                        label="Serienummer utstyr:"
                        value={data.generellInfo?.serienummerUtstyr}
                        onChange={(e) => onUpdateEditData("generellInfo.serienummerUtstyr", e.target.value)}
                      />
                    </>
                  )}
                </div>
              </div>
              <div>
                <VSpace />
                <McTextAreaNew
                  label="Generelt:"
                  value={data.generellInfo?.generelt}
                  onChange={(e) => onUpdateEditData("generellInfo.generelt", e.target.value)}
                />
              </div>
              <div>
                <VSpace />
                <McTextAreaNew
                  label="Sammendrag:"
                  value={data.generellInfo?.sammendrag}
                  onChange={(e) => onUpdateEditData("generellInfo.sammendrag", e.target.value)}
                />
              </div>
            </Stack>
          </Paper>
        </>
      )}
    </div>
  );
};
export default GKgenerellInfo;